import { Flex, Text } from "@mantine/core";
import { BOOKINK_LINK } from "constants";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function EventBuyingSummary({ reduxstate }) {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const BOOKINKLINK = window.localStorage.getItem(BOOKINK_LINK);
  const selectedEventPricing = reduxstate?.selectedEventPricing?.filter(
    (ticket) => ticket.bookingQty && ticket.bookingQty > 0
  );
  const addonsPricingList = reduxstate?.addonsPricingList?.filter(
    (addon) => "bookingQty" in addon && addon.bookingQty > 0
  );
  // if (!reduxstate && !reduxstate?.processingFee || !reduxstate?.processingFeeText || !reduxstate?.totalPrice) {
  //   // alert(BOOKINKLINK)
  //   navigate(`${BOOKINKLINK}`, { replace: true });
  //   return;
  // }
  return (
    <div className="bg-white px-4">
      <div className="p-4 bg-white border-2 border-gray-300 hover:border-secondary rounded-xl">
        <div className="flex justify-center items-center">
          {/* <div className="text-lg font-bold">
            Order Details
          </div> */}
        </div>
        <div className="flex flex-col gap-2">
          {selectedEventPricing && selectedEventPricing.length > 0 && selectedEventPricing.map((ticket, index) => (
            <div
              key={index}
              className="flex justify-between items-center gap-2"
            >
              <div className="flex flex-col gap-1">
                <div className="font-bold">{ticket.ticketType}</div>
                <div className="text-sm text-gray-500">
                  {ticket.bookingQty} X €{(ticket.absorbServiceFee
                          ? Number(ticket.amount)
                          : Number(ticket.amount) + Number(ticket.serviceFee)).toFixed(2)}
                </div>
              </div>
              <div className="flex flex-col" >
                <div className="font-bold">€{Number(ticket.totalPrice).toFixed(2)}</div>
              </div>
            </div>
          ))}
          {addonsPricingList && addonsPricingList.length > 0 && addonsPricingList.map((addon, index) => (
            <div
              key={index}
              className="flex justify-between items-center gap-2"
            >
              <div className="flex flex-col gap-1">
                <div className="font-bold">{addon.addonName}</div>
                <div className="text-sm text-gray-500">
                  {addon.bookingQty} X €
                  {(Number(addon.amountForTicket) +
                    Number(addon.serviceFee > 0 ? addon.serviceFee : 0)).toFixed(2)}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="font-bold">€{Number(addon.totalPrice).toFixed(2)}</div>
              </div>
            </div>
          ))}
          <div className="flex justify-between items-center gap-2">
            <div className="flex flex-col items-center gap-1" >
              <div className="font-bold">Processing Fee</div>
              <div className="text-sm text-gray-500">
                {reduxstate?.processingFeeText && reduxstate?.processingFeeText.replace(/\+\s*\+/g, "+")}
              </div>
            </div>
            <div className="font-bold">€{reduxstate?.processingFee}</div>
          </div>

          <div
            className="flex justify-between items-center gap-2 bg-[#F4F4F4] p-3 rounded-xl"
          >
            <div className="text-lg">{t("order.totalVat")}</div>
            <div className="text-lg font-semibold">
              €
              {Number.isInteger(reduxstate?.totalPrice)
                ? Number(reduxstate?.totalPrice).toFixed(2)
                : Number(reduxstate?.totalPrice).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
